// @flow
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import RadioButton from './RadioButton';
import I18n from '../../../../lib/i18n';
import type { InputProps } from 'redux-form';

export default class GenderRadioButtons extends Component<Props> {
  styles = getStyles();

  selectMale = () => {
    this.props.input.onChange('MALE');
  };

  selectFemale = () => {
    this.props.input.onChange('FEMALE');
  };

  render() {
    const { disabled, style, input } = this.props;
    const styles = this.styles;
    const isFemale = input.value === 'FEMALE';

    return (
      <View style={styles.container}>
        <RadioButton
          disabled={disabled}
          isActive={isFemale}
          label={I18n.t('gender.FEMALE')}
          onSelect={this.selectFemale}
          style={style}
        />
        <RadioButton
          disabled={disabled}
          isActive={!isFemale}
          label={I18n.t('gender.MALE')}
          onSelect={this.selectMale}
          style={style}
        />
      </View>
    );
  }
}

const getStyles = () =>
  StyleSheet.create({
    container: {
      flexDirection: 'row',
    },
  });

type Props = {
  input: InputProps,
  style: Object,
  disabled: boolean,
};
